import { Base } from "../../../../../base/components/base"
import services from "../../../../../services"
import { RateHeader } from "../../rate-table/rate-header"
import { RateTr } from "../../rate-table/rate-tr"
import { Loading } from "../../shared/loading"
import { submitButton } from "../../shared/submit-button"
import { Tab } from "../tab"


export const CadTab = () => {
    const base = Tab('cad')

    const table = Base('table')
    table.cssClass({ direction: 'rtl', borderSpacing: '0', width: '716px' })
    base.append(table)

    const header = RateHeader()
    table.append(header)

    const allowed_cad = [
        'cad_cash_buy',//خرید نقدی دلار کانادا 
        'cad_cash_sell',//فروش نقدی دلار کانادا 
        'cad_remit_sell', //فروش حواله دلار کانادا
        'cad_remit_buy', //خرید حواله دلار کانادا
        'cad_remit_sell_eft', //فروش حواله EFT
        'cad_remit_sell_uni', //فروش حواله دانشگاه
        'eur_remit_sell_eu' //فروش حواله یورو(داخل اتحادیه)
    ]

    const loading = Loading()
    base.append(loading)

    let rows: any[] = []
    services.rates.getRates().then(rates => {
        loading.remove()
        rates.forEach(rate => {
            if (!allowed_cad.includes(rate.key)) return
            const row = RateTr(rate)
            rows.push(row)
            table.append(row)
        })

        const bigButton = submitButton()
        bigButton.enable()
        const row2 = RateTr()
        row2.style({ height: '80px', borderTop: '1px solid #ccc', padding: '10px' })
        row2.append(bigButton)
        table.append(row2)

        bigButton.el.onclick = async () => {
            const rowsToUpdate = rows.filter(row => {
                const val = row.getValue()
                if (val.changed === false) return false
                if (val.meta.db === false) return false
                return true
            })

            console.log('> click:', rowsToUpdate.map(row => row.getValue()));


            bigButton.disable()
            bigButton.el.innerText = 'در حال به روز رسانی...'

            let hasError = false
            for (const row of rowsToUpdate) {
                const item = row.getValue()
                try {
                    await services.rates.updateRate({ item: item.value, change: item.value.change, telegramShouldUpdate: false, details: item.value.details, title: item.value.title })
                    row.update(item.value.value, item.value.details)
                } catch (error) {
                    console.log('error:', error)
                    hasError = true
                }
            }

            if (hasError) {
                bigButton.el.innerText = 'خطا در به روز رسانی'
            } else {
                bigButton.el.innerText = 'اطلاعات به روز شد'
            }
            setTimeout(() => {
                bigButton.el.innerText = 'به روز رسانی اطلاعات'
                bigButton.enable()
            }, 3000);

        }
    })

    return base
}